var map = {
	"./icon-action-default.png": 38019,
	"./icon-action-interactive.png": 99232,
	"./icon-action-listen.png": 7051,
	"./icon-action-question.png": 48330,
	"./icon-action-quiet.png": 14284,
	"./icon-action-raisehand.png": 98423,
	"./icon-action-sing.png": 98615,
	"./icon-action-speak.png": 51446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99117;